import styled from "styled-components";
import { Link } from "wouter";

import { SPACING } from "../../utils/constants";

export const SectionCard = styled.section`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  background: var(--color-card-background);
  border: 1px solid var(--color-border);
  border-radius: 16px;
  padding: ${SPACING.lg}px;
  box-shadow: var(--shadow-small);
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${SPACING.sm}px;
  flex-wrap: wrap;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  color: var(--color-text-default);
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-lg);
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1.3;
`;

export const Stats = styled.dl`
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACING.lg}px;
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
  min-width: 0;
`;

export const StatLabel = styled.dt`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
`;

export const StatValue = styled.dd`
  margin: 0;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: ${SPACING.sm}px;
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-xxl);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--color-text-default);
`;

export const StatLink = styled(Link)`
  font-size: var(--text-sm);
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`;

export const AdjustmentList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--color-border);
`;

export const AdjustmentRow = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.md}px;
  padding: ${SPACING.sm}px 0;
  border-bottom: 1px solid var(--color-border);
`;

export const AdjustmentSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xxs}px;
  min-width: 0;
`;

export const AdjustmentTitle = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  color: var(--color-text-default);
`;

export const AdjustmentMeta = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  overflow-wrap: anywhere;
`;

export const AdjustmentAmount = styled.span`
  font-family: "Crimson Pro", sans-serif;
  font-size: var(--text-base);
  font-variant-numeric: tabular-nums;
  color: var(--color-text-default);
  white-space: nowrap;
`;

export const AdjustmentActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.md}px;
`;
